export const FETCH_SUPPORT_LIST = 'support.fetchSupportList';
export const SAVE_SUPPORT_LIST = 'support.saveSupportList';
export const DELETE_SUPPORT = 'support.deleteSupport';
export const GET_USERS = 'users';
